import { store } from '../../../../../../resources/frontend/js/store/index';
import sbPopup from '../../../../mixins/utils/sb-popup';
import { leadIsSent } from '@form/utils/send-lead';

export const sherlockCheck = data => {
    let leadSuccess = true;

    if (data.success === false) {
        const errorMessage = data.errors ? data.errors[0] : '';

        switch (errorMessage) {
            case 'Invalid Postal Code':
                store.commit('form/setFieldData', { name: 'zipcode', key: 'validate', value: false });
                store.commit('form/setFieldData', { name: 'zipcode', key: 'preValidate', value: false });
        }

        sbPopup(store.state.page.notificationText, 'error');
        store.commit('form/setAttribute', { key: 'loading', value: false });
        return;
    }

    if (data.isDuplicate === true) leadSuccess = false;

    leadIsSent(data.eventId || '', leadSuccess, data.sms_verification_sent);
};
